






















import { Vue, Component } from "@/shared/vuepack";
import SecureDocumentUploadComponent from "@/employee/components/landing-pages/SecureDocumentUploadComponent.vue";

@Component({
  components: {
    SecureDocumentUploadComponent
  }
})
export default class SecureDocumentUpload extends Vue {
}

